import { useState, useEffect } from 'react';

// Matches Chakra's `md` breakpoint (48em = 768px): below it we render the
// mobile chat layout, at/above it the desktop one. Uses matchMedia so the
// switch happens live as the viewport width changes.
const QUERY = '(max-width: 767px)';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(
        () => (typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false)
    );

    useEffect(() => {
        const mql = window.matchMedia(QUERY);
        const onChange = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, []);

    return isMobile;
};

export default useIsMobile;
